import enums from '@/utils/enum'

const compareLowerCase = (input: string, comparisonString: string) =>
  input.toLowerCase() === comparisonString.toLowerCase()

export default {
  isCompany(accountType: string) {
    return compareLowerCase(accountType, enums.accountTypes.company)
  },

  isFreelancer(accountType: string) {
    return compareLowerCase(accountType, enums.accountTypes.freelancer)
  },

  isOrganisation(accountType: string) {
    return (
      compareLowerCase(accountType, enums.accountTypes.organisation) ||
      compareLowerCase(accountType, enums.accountTypes.organization)
    )
  },

  isRecruiter(accountType: string) {
    return compareLowerCase(accountType, enums.accountTypes.recruiter)
  },

  isWorker(accountType: string) {
    return compareLowerCase(accountType, enums.accountTypes.worker)
  },
}
